import {useState} from 'react';
import {Search} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import VoicesList from './voices-list';
import './voice-search.scss';

function VoiceSearch(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState('');

  return (
    <div className='voice-search-container'>
      <label>جستجو</label>

      <Search
        aligned='right'
        loading={isLoading}
        value={value}
        results={props.selectedVoices.map(voice => ({
          key: voice.id,
          title: voice.name,
          description: voice['referenceItem']['repr']
        }))}
        onSearchChange={handleSearchChange(props, setIsLoading, setValue)}
        onResultSelect={handleResultSelect(props, setValue)}
        noResultsMessage='موردی یافت نشد!'
      />
    </div>
  );
}

function handleResultSelect(props, setValue) {
  return function (event, {result}) {
    setValue(result.title);
    props.setSelectedVoices([props.allVoices.find(voice => voice.id === result.key)]);
  };
}

function handleSearchChange(props, setIsLoading, setValue) {
  return function (event, {value}) {
    setIsLoading(true);
    setValue(value);
    setTimeout(() => {
      if (value.length < 1) {
        setIsLoading(false);
        setValue('');
        props.setSelectedVoices(props.allVoices);
        return;
      }
      setIsLoading(false);
      props.setSelectedVoices(props.allVoices.filter(
        voice => (voice.name.includes(value) || voice['referenceItem']['repr'].includes(value))
      ));
    }, 300);
  };
}

VoicesList.propTypes = {
  allVoices: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedVoices: PropTypes.arrayOf(PropTypes.object).isRequired,
  setSelectedVoices: PropTypes.func.isRequired
};

export default VoiceSearch;
